function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9.016 0C11.769 0 14 2.239 14 5a4.993 4.993 0 01-4.774 4.996l-.21.004-.147-.146v-.809l.147-.145A3.892 3.892 0 0012.9 5a3.893 3.893 0 00-3.69-3.895L9.015 1.1H4.984A3.892 3.892 0 001.1 5a3.893 3.893 0 003.69 3.895l.194.005.147.145v.81L4.984 10C2.231 10 0 7.761 0 5A4.993 4.993 0 014.774.004L4.984 0h4.032zm-2.02 2.75l.094.034 2.29 1.874.02.204-.508.627-.208.02-1.135-.93.001 5.275-.147.146h-.806l-.147-.146V4.597l-1.082.907-.208-.018-.516-.62.018-.205 2.24-1.876.095-.034z",
  fill: "#31C4CC",
  fillRule: "nonzero"
});

var SvgIcLoginNormal = function SvgIcLoginNormal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10
  }, props), _ref);
};

export default SvgIcLoginNormal;